new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,
        imgSrc: '',
        imgTitle: '',
        isVideo: ''
    },
    methods: {
        resizeThumbs() {
            const contentThumbs = document.querySelector('#product-photo');
            const imgThumb = document.querySelector('#product-photo img');
            if(contentThumbs && imgThumb) {
                let heightImg = imgThumb.getBoundingClientRect().height;
                contentThumbs.style.minHeight = heightImg + 'px';
            }
        },
        clickThumbs() {
            let photoArea = document.querySelector('.product-detail__header--photoArea');
            let photoThumbs = document.querySelector('.product-detail__header--photoArea-thumbs');

            if(photoThumbs && photoArea) {
                if (photoArea.classList.contains('gallery-left') || photoArea.classList.contains('gallery-right') || photoArea.classList.contains('gallery-bottom')) {

                    let photoListItem = document.querySelectorAll('#photo-list li');
                    let singlePhotoItem = document.querySelectorAll('#product-photo img');
    
                    if(photoListItem.length && singlePhotoItem.length) {
                        photoListItem[0].classList.add('active');
                        singlePhotoItem[0].classList.add('active');
    
                        function activeTab(index) {
                            singlePhotoItem.forEach((content) => {
                              content.classList.remove('active');
                            });
                            singlePhotoItem[index].classList.add('active');
                        }
        
                        photoListItem.forEach((itemMenu, index) => {
                            itemMenu.addEventListener('click', () => {
                              activeTab(index);
                            });
                        });
                    }
                }
            }

            if(photoThumbs && photoArea) {
                if (photoThumbs.classList.contains('gallery-left') || photoThumbs.classList.contains('gallery-right')) {
                    $('#photo-list').slick({
                        infinite: false,
                        slidesToShow: 4,
                        vertical: false,
                        slidesToScroll: 1,
                        arrows: true,
                        responsive: [
                            {
                                breakpoint: 991,
                                settings: {
                                    vertical: true,
                                }
                            },
                        ]
                    });
                }else if (photoThumbs.classList.contains('gallery-bottom')) {
                    $('#photo-list').slick({
                        infinite: false,
                        slidesToShow: 4,
                        vertical: false,
                        slidesToScroll: 1,
                        arrows: true
                    });
                }
            }else if (photoArea && photoArea.classList.contains('default')) {
                $('#product-photo ul').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: false,
                    infinite: true,
                    mobileFirst: true,
                    speed: 700,
                    vertical: false,
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: "unslick"
                        },
                    ]
                });
            }
        },
        updateImageThumb(src) {
            this.imgSrc = src;
        },
        setThumbHeight() {
            return document.querySelector('.product-detail__header--photoArea-thumbs').style.height = document.querySelector('#photo-list li.visible').clientHeight * this.slidesToShow + 'px;';
        },
        handleESC(event) {
            if (event.key === 'Escape')
              this.showOpened = false
        },
        checkBuyView() {
            const buyButton = document.getElementById("buy-button");
            const rect = buyButton.getBoundingClientRect();
            
            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.remove("active");
                }
            } else {
            const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.add("active");
                }
            }
        },
        zoom(event) {
            const container = document.getElementById('zoom-container');
            const image = document.getElementById('zoom-image');

            const containerRect = container.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left;
            const mouseY = event.clientY - containerRect.top;

            if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
                const zoomLevel = 1.2;
                const newWidth = container.offsetWidth * zoomLevel;
                const newHeight = container.offsetHeight * zoomLevel;

                const offsetX = -(mouseX * (zoomLevel - 1));
                const offsetY = -(mouseY * (zoomLevel - 1));

                image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;

                if (offsetX > 0) {
                image.style.transform = `translate(0, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY > 0) {
                image.style.transform = `translate(${offsetX}px, 0) scale(${zoomLevel})`;
                }
                if (offsetX < -(newWidth - container.offsetWidth)) {
                image.style.transform = `translate(${- (newWidth - container.offsetWidth)}px, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY < -(newHeight - container.offsetHeight)) {
                image.style.transform = `translate(${offsetX}px, ${- (newHeight - container.offsetHeight)}px) scale(${zoomLevel})`;
                }
            }
        },
        resetZoom() {
            const image = document.getElementById('zoom-image');
            image.style.transform = 'translate(0, 0) scale(1)';
        },
        handleStickyInfoArea() {
            let lastScrollTop = 0; // Variável para armazenar o valor do scroll anterior
            const isDesktop = window.innerWidth > 991;
            const photoArea = document.querySelector('.product-detail__header--photoArea');
            const infoArea = document.querySelector('.product-detail__header--infoArea');
            const container = document.querySelector('#product-detail');
            const wrapper = document.querySelector('.product-detail__header');
            const header = document.querySelector('header'); // O seu header que possui a transição
          
            if (!photoArea || !infoArea || !container || !wrapper || !header) return;
          
            const photoIsDefault = photoArea.classList.contains('default');
          
            if (!isDesktop || !photoIsDefault) {
              infoArea.style.position = '';
              infoArea.style.top = '';
              infoArea.style.right = '';
              infoArea.style.width = '';
              return;
            }
          
            const containerStyle = getComputedStyle(container);
            const containerPaddingTop = parseFloat(containerStyle.paddingTop) || 0;
          
            // O valor inicial de top deve ser 30px + padding-top do container
            const minTop = 30 + containerPaddingTop;
          
            // Definir o topo inicial apenas na carga da página
            infoArea.style.position = 'fixed';
            infoArea.style.top = `${minTop}px`;
            infoArea.style.right = '70px';
            
            const usableWidth = wrapper.offsetWidth - 140; // padding 70px de cada lado
            const infoWidth = usableWidth * 0.41666667 - 15;
            infoArea.style.width = `${infoWidth}px`;
          
            // Função para verificar o scroll e atualizar a posição do infoArea
            function onScroll() {
              const st = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
              const scrollDifference = st - lastScrollTop;
              const containerRect = container.getBoundingClientRect();
              const containerTop = st + containerRect.top;
              const containerBottom = containerTop + container.offsetHeight;
              const infoHeight = infoArea.offsetHeight;
          
              // Distância do topo com base no scroll + padding do container
              const distanceFromTop = st - containerTop + containerPaddingTop;
          
              let top = minTop;  // Inicia com o valor de top correto
          
              // Quando a .infoArea estiver a menos de 30px do topo da tela, atualiza o top para ficar visível
              if (distanceFromTop < 30) {
                top = Math.max(minTop, distanceFromTop); // Não deixa o top ficar abaixo de 30px
              } else {
                top = 30;
              }
          
              // Se o infoArea ultrapassaria o final do container, limita a posição do top
              const maxTop = containerBottom - st - infoHeight;
              if (top > maxTop) {
                top = maxTop;
              }
          
              // Se o scroll estiver no topo, garante que o top volte ao valor inicial (30px + padding-top)
              if (st <= containerTop) {
                top = minTop; // Resetando o top para o valor inicial quando o scroll chega ao topo
              }
          
              // Aqui, vamos garantir que o infoArea só se mova após o header começar a sumir
              const headerHeight = header.offsetHeight;
              const scrollTrigger = 90; // O ponto em que o header começa a desaparecer
          
              if (st >= scrollTrigger && scrollDifference > 0) {
                // O header começou a desaparecer, agora o infoArea pode se mover
                if (st >= scrollTrigger) {
                  infoArea.style.top = `${top}px`;
                }
              } else {
                // O header ainda está visível, então o infoArea fica no topo
                infoArea.style.top = `${minTop}px`;
              }
          
              // Verificar se estamos scrollando de baixo para cima e evitar que o header sobreponha o infoArea
              if (scrollDifference < 0) {
                // Scroll de baixo para cima
                if (st <= containerTop) {
                  // Garantir que o infoArea não seja sobreposto
                  infoArea.style.top = `${minTop}px`;
                }
              }
          
              // Atualizar o valor do scroll para o próximo cálculo
              lastScrollTop = st <= 0 ? 0 : st; // Nunca deixar o valor de scroll ser negativo
            }
          
            // Monitorar o scroll de forma contínua
            window.addEventListener('scroll', onScroll);
        },

        moveToBuy() {
            var productSize = document.getElementById("buy-button");
            if (productSize) {
                productSize.scrollIntoView({ 
                    behavior: "smooth", 
                    block: "center" // Isso vai centralizar o elemento na tela
                });
            }
        }
    },
    mounted() {
        this.resizeThumbs();
        this.clickThumbs();

        let description = document.querySelector('.description-nav');
        if (description) {
            let navTab = description.querySelectorAll('.nav-item');
            let navShow = description.querySelectorAll('.description-nav-content');
            navTab = Array.from(navTab);
            navShow = Array.from(navShow);
        
            if (navTab.length && navShow.length) {
                navShow.forEach((content) => {
                    let height = content.scrollHeight;
                    content.style.height = height + 'px';
                    content.classList.add('active');
                });
        
                navTab.forEach((content) => {
                    content.classList.add('active');
                });
        
                navTab[0].classList.remove('active');
                navShow[0].classList.remove('active');
        
                function activeTab(index) {
                    navTab.forEach((content) => {
                        content.classList.add('active');
                    });
                    navTab[index].classList.remove('active');
                    navShow.forEach((content) => {
                        content.classList.add('active');
                    });
                    navShow[index].classList.remove('active');
        
                    // Espera o transition terminar para fazer scrollIntoView
                    const onTransitionEnd = () => {
                        description.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                        navTab[index].removeEventListener('transitionend', onTransitionEnd);
                    };
        
                    navTab[index].addEventListener('transitionend', onTransitionEnd);
                }
        
                navTab.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', () => {
                        activeTab(index);
                    });
                });
            }
        }
        
        
        

        let navTab = document.querySelector('.product-detail__nav');
        if(navTab) {
            let navItem = navTab.querySelectorAll('.nav-item');
            navItem.forEach((item) => {
                let navShow = item.querySelector('.product-detail__nav-content');
                let itemOpen = item.querySelector('.nav-item-open');
                let sidebarInner = document.querySelector('.product-detail__header--infoArea .sidebar__inner');
                let infoArea = document.querySelector('.product-detail__header--infoArea');
                itemOpen.addEventListener('click', () => {
                    navShow.classList.toggle('active');
                    itemOpen.classList.toggle('active');
                    if(sidebarInner && infoArea) {
                        let sidebarHeight = sidebarInner.getBoundingClientRect().height;
                        let childToParentDistance = sidebarInner.offsetTop;
                        infoArea.style.height = (childToParentDistance + sidebarHeight) + 'px';
                    }
                })
            })
        }

        let navTabDois = document.querySelector('.product-detail__nav-dois');
        let nav = document.querySelector('.product-detail__nav-dois-tab');
        let navItem = nav ? nav.querySelectorAll('.nav-dois-item') : [];
        let navContent = document.querySelector('.product-detail__nav-dois-content');
        let navShow = navContent ? navContent.querySelectorAll('.nav-dois-show') : [];

        if (navTabDois && navItem.length && navShow.length) {
            navItem = Array.from(navItem);
            navShow = Array.from(navShow);

            navItem[0].classList.add('active');
            navShow[0].classList.add('active');

            function activeTab(index) {
                navShow.forEach((content) => {
                    content.classList.remove('active');
                });
                navShow[index].classList.add('active');
            }

            navItem.forEach((itemMenu, index) => {
                itemMenu.addEventListener('click', () => {
                    activeTab(index);
                    navItem.forEach((item) => {
                        item.classList.remove('active'); // Adicionado para remover a classe 'active' dos outros itens
                    });
                    itemMenu.classList.add('active'); // Adicionado para adicionar a classe 'active' ao item clicado
                });
            });
        } 
        
        const photoList = document.getElementById("photo-list");
        if (photoList) {
        const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");
                
                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });

          window.addEventListener('scroll', this.handleStickyInfoArea, { passive: true });
          window.addEventListener('resize', this.handleStickyInfoArea, { passive: true });
          window.addEventListener("load", this.handleStickyInfoArea, { passive: true });
          
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
    watch: {
        showOpened(newValue) {
          if (newValue) {
            document.body.style.overflow = 'hidden';
          } else {
            document.body.style.removeProperty('overflow');
          }
        },
    }
})

$(document).ready(function () {

    $("body").on("click", ".btn-group.btn-minus", function(event) {
        var $this = $(this);
        var clt = $this.closest(".amount-fake");
        var qt_el = clt.find(".product-detail__qtd--input");
        var qtd = parseInt(qt_el.val());
    
        if (isNaN(qtd)) {
            qtd = 1;
        }
    
        if (qtd > 1) qtd--;
        qt_el.val(qtd);
    
        // Atualiza o input espelho
        $("#product_qtd__product_detail").val(qtd);
    });
    
    $("body").on("click", ".btn-group.btn-plus", function(event) {
        var $this = $(this);
        var clt = $this.closest(".amount-fake");
        var qt_el = clt.find(".product-detail__qtd--input");
        var qtd = parseInt(qt_el.val());
    
        if (isNaN(qtd)) {
            qtd = 1;
        } else {
            qtd++;
        }
    
        qt_el.val(qtd);
    
        // Atualiza o input espelho
        $("#product_qtd__product_detail").val(qtd);
    });
    
    // Se quiser também pegar quando o usuário digita manualmente
    $("body").on("input", ".product-detail__qtd--input", function() {
        var val = $(this).val();
        $("#product_qtd__product_detail").val(val);
    });
    

    const aboutThemes = document.querySelector('.duvidas');
    if (aboutThemes) {
        const duvidasItem = document.querySelectorAll('.duvidas-list li');
        if (duvidasItem.length) {
            duvidasItem.forEach((item) => {
                item.addEventListener('click', (e) => {
                    item.classList.toggle('active');
                });
            });
        }
    }

    if (window.matchMedia("(min-width: 992px)").matches) {
        function animeScroll() {
            const photoScroll = document.querySelector('.product-detail__header--photoArea');
            const sidebarInner = document.querySelector('.sidebar__inner');
    
            if (photoScroll && sidebarInner && photoScroll.offsetHeight > sidebarInner.offsetHeight) {
                const containerWidth = $('.product-detail__header--infoArea').width();
                const sidebarInnerHeight = sidebarInner.offsetHeight;
                const totalHeight = photoScroll.offsetHeight - sidebarInnerHeight;
                const pageTop = window.pageYOffset;
                const rect = photoScroll.getBoundingClientRect();
                const offsetTop = rect.top + pageTop; // Calculate the distance from top of the page to the photoScroll
    
                if (pageTop > (offsetTop + totalHeight)) {
                    $('.sidebar__inner').css({ position: 'relative', top: totalHeight + 'px', maxWidth: '100%' });
                } else if (pageTop > offsetTop) {
                    $('.sidebar__inner').css({ position: 'fixed', top: '0px', maxWidth: containerWidth + 'px' });
                } else {
                    $('.sidebar__inner').css({ position: 'relative', top: '0px', maxWidth: '100%' });
                }
            }
        }
    
        window.addEventListener('scroll', function() {
            animeScroll();
        });
    
        animeScroll();
    } 

    const brinde = document.querySelector('#js_buy_together_api_layout_2');
    if (brinde) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');
        
                            if (options && figcaption) {
                                figcaption.append(options);
                            }
        
                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');
        
                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });
        
                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');
        
                            if (options && figcaption) {
                                figcaption.append(options);
                            }
        
                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');
        
                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });
        
                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                    }
                });
            });
        });
        
        observer.observe(brinde, {
            childList: true,
            subtree: true
        });
        
    }

    if($('.product-photo-background')) {
        $('.product-photo-background').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            speed: 700,
            vertical: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true, 
                    }
                },
            ]
        });
    }

    if($('.product-detail__header--photoArea-mobile')) {
        $('.product-detail__header--photoArea-mobile').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            speed: 700,
            vertical: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                },
            ]
        });
    }

    if($('#like-carousel')) {
        $('#like-carousel').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            speed: 700,
            vertical: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                },
            ]
        });
    }

    if($('#product-detail-related-carrousel')) {
        $('#product-detail-related-carrousel').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                    }
                },
            ]
        });

        $('#product-detail-related-carrousel').on('afterChange', function(event, slick, currentSlide, nextSlide){
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function(element) {
                    setTimeout(function(){
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                    }, 200);
                }
            });
        });
    }

    $('#photo-fancy').fancybox();
})